import styled from "styled-components";

export const PrimaryLabelBox = styled.div`
  
`
